export default __webpack_public_path__ + "static/media/hourglass.d008f395.png";